export class GetDirectoryEntityResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "entityId",
            "baseName": "entityId",
            "type": "string",
            "format": ""
        },
        {
            "name": "entityType",
            "baseName": "entityType",
            "type": "DirectoryEntityType",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "attributesJson",
            "baseName": "attributesJson",
            "type": "string",
            "format": ""
        },
        {
            "name": "roleAssignmentSummary",
            "baseName": "roleAssignmentSummary",
            "type": "DirectoryRoleAssignmentSummary",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetDirectoryEntityResponse.attributeTypeMap;
    }
    constructor() {
    }
}
